import { HttpService } from "@/core";

export class CompleteContractService {

  // 完成合同
  static useCompleteContractChangeApi() {
    const api = (bizId: string, bizType: string, contractStatus: string = '', ) =>
      HttpService.axios({
        method: "PUT",
        url: `/common_api/contractStatusUpdate/${bizId}/${bizType}/${contractStatus}`,
      });
    return HttpService.useRequest(api);
  }


}
